import { Instruction } from "@atlaskit/pragmatic-drag-and-drop-hitbox/list-item"

export function getDragIndicator({ instruction }: { instruction: Instruction }): HTMLElement {
  const { operation } = instruction
  const element = document.createElement("div")
  element.setAttribute("data-operation", operation)

  element.classList.add(
    "drag-indicator",
    "horizontal",
    operation,
  )
  return element
}
